import { Box, Image } from '@chakra-ui/react';
import type { Msg } from '@halo/chat-sdk';

export interface MessageLuckyBoxProps {
  message: Msg;
  onClick?: (message: Msg) => void;
  previewCoverBgImg?: string;
}

export function MessageLuckyBox({ message, previewCoverBgImg, onClick }: MessageLuckyBoxProps) {
  return (
    <Box fontSize="sm" position="relative">
      <Image
        w="calc(114px + var(--text-scale-factor, 0px))"
        src={previewCoverBgImg}
        alt="lucky box"
        onClick={() => {
          onClick?.(message);
        }}
        cursor="pointer"
      />
    </Box>
  );
}
